<template>
  <div class="wallet">
    <div class="priceDataClass">
      <div class="wallet-title">
        <div class="amount">{{ priceData.balance | money }}</div>
        <div class="desc">钱包余额</div>
      </div>
      <div class="wallet-title">
        <div class="amount">{{ priceData.withdrawalBalance | money }}</div>
        <div class="desc">可提现余额</div>
      </div>
      <div class="wallet-title">
        <div class="amount">{{ priceData.lastMonthBalanceProfit | money }}</div>
        <div class="desc">上月余额收益</div>
      </div>
    </div>
    <div class="priceDataClass">
      <div class="wallet-title">
        <div class="amount">{{ priceData.lastMonthOnlineProfit | money }}</div>
        <div class="desc">上月线上收益</div>
      </div>
      <div class="wallet-title">
        <div class="amount">{{ priceData.lastMonthProfit | money }}</div>
        <div class="desc">上月收入</div>
      </div>
      <div class="wallet-title">
        <div class="amount">{{ priceData.currentMonthBalanceProfit | money }}</div>
        <div class="desc">当月余额收益</div>
      </div>
    </div>
    <div class="priceDataClass">
      <div class="wallet-title">
        <div class="amount">{{ priceData.currentMonthOnlineProfit | money }}</div>
        <div class="desc">当月线上收益</div>
      </div>
      <div class="wallet-title">
        <div class="amount">{{ priceData.currentMonthProfit | money }}</div>
        <div class="desc">当月余额收入</div>
      </div>
      <div class="wallet-title">
        <div class="amount">{{ priceData.oldTotalWithdrawalEnd | money }}</div>
        <div class="desc">历史总提现金额</div>
      </div>
    </div>
    <div class="priceDataClass">
      <div class="wallet-title">
        <div class="amount">{{ priceData.oldTotalOnlineProfit | money }}</div>
        <div class="desc">历史线上总收益</div>
      </div>
      <div class="wallet-title">
        <div class="amount"></div>
        <div class="desc"></div>
      </div>
      <div class="wallet-title">
        <div class="amount"></div>
        <div class="desc"></div>
      </div>
    </div>
    <div class="wallet-operation">
      <van-button size="small" type="primary" @click="$router.push({ name: 'Withdraw' })">申请提现</van-button>
    </div>
    <List :page="page" @requestList="handleLoad">
      <OrderCell :orderList="walletList" :cellList="cellList">
        <template v-slot:order-status="{item}">
          <span :style="{ color: item.status === 1 ? '#ff976a' : '#339900' }">{{ item.status | status }}</span>
        </template>
         <template v-slot:order-footer="scoped">
          <div class="order-footer">
            <van-button
              size="small"
              @click="$router.push({ name: 'WithdrawDetails', params: { id: scoped.item.id } })"
            >查看详情</van-button>
          </div>
        </template>
      </OrderCell>
    </List>
  </div>
</template>

<script>
import { balance, settlementList } from '@/api/wallet';
import List from '@/components/list';
import OrderCell from '@/components/order/cell';
import { money } from '@/filters';
export default {
  name: 'Wallet',
  components: { List, OrderCell },
  data() {
    return {
      priceData: {
        balance: 0,
        withdrawalBalance: 0, // 可提现金额
        lastMonthBalanceProfit: 0, // 上个月余额收益
        lastMonthOnlineProfit: 0, // 上个月线上收益
        lastMonthProfit: 0, // 上个月收入
        currentMonthBalanceProfit: 0, // 当月余额收益
        currentMonthOnlineProfit: 0, // 当月线上收益
        currentMonthProfit: 0, // 当月余额收入
        oldTotalWithdrawalEnd: 0, // 历史总提现金额
        oldTotalOnlineProfit: 0 // 历史线上总收益
      },
      walletList: [],
      cellList: [
        { title: '提现金额', value: 'tradeMoney', border: true, filter: money },
        { title: '申请时间', value: 'created' },
        { title: '结算单号', value: 'orderNo' },
        { title: '原始金额', value: 'money', filter: money },
        { title: '钱包余额', value: 'balance', filter: money },
        { title: '处理状态', value: 'status', slot: 'order-status' }
      ],
      loadding: false,
      page: {
        totalCount: 0,
        currentPage: 1,
        currentCount: 10,
        totalPage: 0
      }
    }
  },
  created() {
    this.getWalletBalance();
    const { currentPage: page, currentCount: count } = this.page;
    this.getWalletList({ page, count });
  },
  filters: {
    status(value) {
      switch(value) {
        case 1:
          return '财务处理中';
        case 2:
          return '已结算';
        default:
          return '';
      }
    }
  },
  methods: {
    /**
     * 滚动加载数据
     */
    handleLoad() {
      const { currentPage: page, currentCount: count } = this.page;
      this.getWalletList({ page: page + 1, count });
    },
    /**
     * 获取钱包余额
     */
    getWalletBalance() {
      balance().then(res => {
        if (res.errcode === 0) {
          this.priceData = res.data;
        }
      })
    },
    /**
     * 获取提现申请列表
     */
    getWalletList(page) {
      settlementList(page).then(res => {
        if (res.errcode === 0) {
          this.walletList = this.walletList.concat(res.data);
          this.page = res.page;
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.wallet {
  .priceDataClass{
    display: flex;
    justify-content: space-around;
    background: #FFF;
    height: 80px;
  }
  .wallet-title {
    display: flex;
    flex-direction: column;
        justify-content: center;
      width: 50%;
     color: #333; background-color: #fff;
    .amount { text-align: center; font-size: 22px; font-weight: 650; overflow: hidden; word-wrap:break-word; word-break:break-all; }
    .desc { text-align: center; font-size: 14px; }
  }
  .wallet-operation { padding: 10px 0 15px 0; text-align: center; background-color: rgba(242, 242, 242, 1);
    .van-button { padding: 0 30px; }
  }
}
</style>